export default __webpack_public_path__ + "static/media/Group 1912.a33a28e2.svg";